import { AnyAction, configureStore, ThunkAction } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'
import socketReducer, { SocketState } from 'src/store/Reducer/socket/socketSlice'
import LoginPageReducer, { LoginPageStateType } from 'src/store/Reducer/page/loginPageSlice'
import ResetPageReducer, { ResetPageStateType } from 'src/store/Reducer/page/resetPageSlice'
import modalReducer, { ModalDataTypes } from 'src/store/Reducer/common/modalSlice'
import ExplorerPageReducer, {
  ExplorerPageStateType,
} from 'src/store/Reducer/page/explorerPageSlice'
import LocationPageReducer, {
  LocationPageStateType,
} from 'src/store/Reducer/page/locationPageSlice'
import BatteryInfoReducer, { BatteryDataType } from 'src/store/Reducer/socket/batterySlice'
import HomePageReducer, { HomeDataType } from 'src/store/Reducer/socket/homePageSlice'
import CameraPageReducer, { CameraPageDataTypes } from 'src/store/Reducer/page/cameraPageSlice'
import ExplorerFileListReducer, {
  ExplorerFileListItemsType,
} from 'src/store/Reducer/socket/ExplorerfileListSlice'
import CommonReducer, { commonStateType } from 'src/store/Reducer/common/commonSlice'
import { combineReducers } from 'redux'
import ConnectionReducer from 'src/store/Reducer/socket/connectionSlice'
import DeviceAuthReducer from 'src/store/Reducer/socket/deviceAuthSlice'
import StorageInfoReducer from 'src/store/Reducer/socket/storageInfoSlice'
import LocationHistoryReducer from 'src/store/Reducer/socket/LocationHistorySlice'
import CurrentLocationReducer from 'src/store/Reducer/socket/currentLocationSlice'
import WifiInfoReducer from 'src/store/Reducer/socket/WifiSlice'
import { ResponseDataBody } from 'src/types/websocket'

export type RootState = {
  socket: SocketState
  LoginPage: LoginPageStateType
  ResetPage: ResetPageStateType
  HomePage: HomeDataType
  resResetPin: ResponseDataBody.PinReset
  connection: ResponseDataBody.Connection
  modal: ModalDataTypes
  isBattery: BatteryDataType
  ExplorerPage: ExplorerPageStateType
  deviceAuth: ResponseDataBody.DeviceAuth
  storageInfo: ResponseDataBody.StorageInfo
  locationHistory: ResponseDataBody.LocationHistory
  currentLocation: ResponseDataBody.CurrentLocation
  explorerFileList: ExplorerFileListItemsType
  explorerDeleteResult: ResponseDataBody.ExplorerDeleteData
  wifiInfo: ResponseDataBody.WifiList
  LocationPage: LocationPageStateType
  CameraPage: CameraPageDataTypes
  common: commonStateType
}

export type AppThunk = ThunkAction<void, RootState, unknown, AnyAction>

const rootReducer = combineReducers({
  socket: socketReducer,
  LoginPage: LoginPageReducer,
  ResetPage: ResetPageReducer,
  HomePage: HomePageReducer,
  connection: ConnectionReducer,
  modal: modalReducer,
  isBattery: BatteryInfoReducer,
  ExplorerPage: ExplorerPageReducer,
  deviceAuth: DeviceAuthReducer,
  storageInfo: StorageInfoReducer,
  locationHistory: LocationHistoryReducer,
  currentLocation: CurrentLocationReducer,
  explorerFileList: ExplorerFileListReducer,
  wifiInfo: WifiInfoReducer,
  LocationPage: LocationPageReducer,
  CameraPage: CameraPageReducer,
  common: CommonReducer,
})

const store = configureStore({
  reducer: rootReducer,
  middleware: [thunkMiddleware],
})

export default store
